import { useWindowWidth } from "@react-hook/window-size";
import { WINDOW_SIZE_LG, WINDOW_SIZE_MD, WINDOW_SIZE_SM, WINDOW_SIZE_XL } from "../constants/window_size";

const useSize = () => {
    const width = useWindowWidth();

    return  [
        width > 0 && width <= WINDOW_SIZE_SM,
        width > WINDOW_SIZE_SM && width <= WINDOW_SIZE_MD,
        width > WINDOW_SIZE_MD && width <= WINDOW_SIZE_LG,
        width > WINDOW_SIZE_LG && width <= WINDOW_SIZE_XL,
        width > WINDOW_SIZE_XL
    ];

};

export default useSize;
